"use client";
import React from "react";
import Image from "next/image";
import { AspectRatio, Center, HStack } from "@chakra-ui/react";
import { Heading } from "@/elements";
import PocCloudWhite from "public/cloud-services/poc-cloud-white.svg";
import PocCloud from "public/cloud-services/poc-cloud.svg";
import PrivateCloudWhite from "public/cloud-services/private-cloud-white.svg";
import PrivateCloud from "public/cloud-services/private-cloud.svg";
import PerformanceStorageTable from "@/views/pricing/components/tables/performanceObjectStorage";
import BlockStorageTable from "@/views/pricing/components/tables/blockStorage";
import { PRICING_HEADING_CONSTANTS } from "./constants";

export const tablist = [
  {
    component: <PerformanceStorageTable />,
    label: ({ isSelected }) => (
      <Center>
        <HStack gap={2}>
          <AspectRatio ratio={1} w={"24px"} position={"relative"}>
            <Image
              alt="private cloud"
              src={isSelected ? PrivateCloudWhite : PrivateCloud}
              fill
              style={{ objectFit: "contain", objectPosition: "center" }}
            />
          </AspectRatio>
          <Heading fontWeight={600} variant={"subTitle3"}>
            {PRICING_HEADING_CONSTANTS.object_storage}
          </Heading>
        </HStack>
      </Center>
    ),
  },
  {
    component: <BlockStorageTable />,
    label: ({ isSelected }) => (
      <Center>
        <HStack gap={2}>
          <AspectRatio ratio={1} position={"relative"} w={"24px"}>
            <Image
              alt="poc cloud"
              src={isSelected ? PocCloudWhite : PocCloud}
              fill
              style={{ objectFit: "contain", objectPosition: "center" }}
            />
          </AspectRatio>
          <Heading fontWeight={600} variant={"subTitle3"}>
            {PRICING_HEADING_CONSTANTS.block_storage}
          </Heading>
        </HStack>
      </Center>
    ),
  },
];
